var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVideoDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 62,
    viewBox: "0 0 64 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 80,
    rx: 8,
    fill: "#F2F2F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3581_1230",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 24,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 24,
    width: 32,
    height: 32,
    fill: "#C0C0C0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3581_1230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2001 45L36.7001 40.8333C37.0112 40.6333 37.1667 40.3556 37.1667 40C37.1667 39.6444 37.0112 39.3667 36.7001 39.1667L30.2001 35C29.8667 34.7778 29.5279 34.7611 29.1834 34.95C28.839 35.1389 28.6667 35.4333 28.6667 35.8333V44.1667C28.6667 44.5667 28.839 44.8611 29.1834 45.05C29.5279 45.2389 29.8667 45.2222 30.2001 45ZM32.0001 53.3333C30.1556 53.3333 28.4223 52.9833 26.8001 52.2833C25.1779 51.5833 23.7667 50.6333 22.5667 49.4333C21.3667 48.2333 20.4167 46.8222 19.7167 45.2C19.0167 43.5778 18.6667 41.8444 18.6667 40C18.6667 38.1556 19.0167 36.4222 19.7167 34.8C20.4167 33.1778 21.3667 31.7667 22.5667 30.5667C23.7667 29.3667 25.1779 28.4167 26.8001 27.7167C28.4223 27.0167 30.1556 26.6667 32.0001 26.6667C33.8445 26.6667 35.5779 27.0167 37.2001 27.7167C38.8223 28.4167 40.2334 29.3667 41.4334 30.5667C42.6334 31.7667 43.5834 33.1778 44.2834 34.8C44.9834 36.4222 45.3334 38.1556 45.3334 40C45.3334 41.8444 44.9834 43.5778 44.2834 45.2C43.5834 46.8222 42.6334 48.2333 41.4334 49.4333C40.2334 50.6333 38.8223 51.5833 37.2001 52.2833C35.5779 52.9833 33.8445 53.3333 32.0001 53.3333ZM32.0001 50.6667C34.9779 50.6667 37.5001 49.6333 39.5667 47.5667C41.6334 45.5 42.6667 42.9778 42.6667 40C42.6667 37.0222 41.6334 34.5 39.5667 32.4333C37.5001 30.3667 34.9779 29.3333 32.0001 29.3333C29.0223 29.3333 26.5001 30.3667 24.4334 32.4333C22.3667 34.5 21.3334 37.0222 21.3334 40C21.3334 42.9778 22.3667 45.5 24.4334 47.5667C26.5001 49.6333 29.0223 50.6667 32.0001 50.6667Z",
    fill: "#C0C0C0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoDocumentIcon);
export default __webpack_public_path__ + "static/media/videoDocumentIcon.0a9837a7714b42b207da04f9ca03be23.svg";
export { ForwardRef as ReactComponent };